import React from 'react';

/**
 * Formats a description string, converting *text* to a <span> with specified color. Orange is the default.
 * @param {string} text
 * @param {string} color
 * @returns {import('react').ReactNode[] | null}
 */
export function highlightInlineText(text, color = 'orange') {
  if (!text) return null;

  const parts = text.split(/(\*[^*]+\*)/g);

  return parts.map((part, i) => {
    if (part.startsWith('*') && part.endsWith('*')) {
      return (
        <span key={i} style={{ color: `var(--color-${color})` }}>
          {part.slice(1, -1)}
        </span>
      );
    }
    return part;
  });
}
